import React from "react";
import logoImg from "@/assets/logo.png";

export const Logo = ({ className = "" }) => (
  <img src={logoImg} alt="sorról sorra" className={className} data-testid="brand-logo" />
);
